import { createContext } from "../ContextSelector";
var ResizeContext = createContext();
export default ResizeContext;